import { handleResponse } from "../../../common/handleLambdaResponse";
import { getIdToken } from "../../userManager/userManagementUtils"

export const getQuotaDetails = (): Promise<string> => {
    return new Promise(async (resolve, reject) => {
        // Example call to Lambda function
        let idToken;
        try {
            idToken = await getIdToken();
        } catch (err) {
            reject(err);
            return
        }
        const params = {
            FunctionName: "get-quotas",
            Payload: JSON.stringify({
                action: "get_quotas",
                token: idToken
            })
        };

        window.lambda.invoke(params, (err: any, resultData: any) => {
            handleResponse(err, resultData, resolve, reject)
        });
    })
}
